var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("oversea-billing", {
    ref: "overseaBilling",
    attrs: {
      context: _vm.context,
      action: _vm.action,
      "view-source": _vm.viewSource,
      location: _vm.location,
      "enable-ui-custom": _vm.enableUiCustom,
      "page-type": _vm.pageType
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }